// import React, { useState, useEffect } from "react";
// import { ethers, BrowserProvider, Eip1193Provider } from "ethers";
// import { Navigation, LoadingPage } from "..";
// import { useUniqueItems, useAIChat } from "../../Hooks";
// import { apiUrl } from "../../Components/config";
// import ExitToAppIcon from "@mui/icons-material/ExitToApp";

// import useWebSocket, { ReadyState } from "react-use-websocket";
// import ReactMarkdown from "react-markdown";

// import { useSnackbar } from "notistack";
// import {
//   Alert,
//   Select,
//   MenuItem,
//   InputAdornment,
//   TextField,
//   Typography,
//   IconButton,
//   Popover,
//   Button,
// } from "@mui/material";

// import Snackbar, { SnackbarCloseReason } from "@mui/material/Snackbar";
// import { WalletAvatar } from "../../Components/WalletAvatar";
// import { AssistantCard } from "../../Components/AssistantCard";
// import "@rainbow-me/rainbowkit/styles.css";
// import { ConnectButton } from "@rainbow-me/rainbowkit";
// import { useAccount, useBalance, useDisconnect } from "wagmi";
// import "./airdrop.css";
// import { radius } from "viem/chains";

export const AirdropPage = () => {
  //   // 获取当前账户信息
  //   const { address, chain, isConnected } = useAccount();

  //   // 使用 useBalance 获取余额
  //   const { data: balance } = useBalance({
  //     address: address,
  //   });

  //   const { disconnect } = useDisconnect();

  //   const [account, setAccount] = useState<string | null>(null);

  //   const [uid, setUID] = useState<number>(0);
  //   const [coins, setCoins] = useState<number>(0);
  //   const [claim, setClaim] = useState<boolean>(false);

  //   const [loading, setLoading] = useState<boolean>(true);
  //   const [error, setError] = useState<string>("");
  //   const [openSnackbar, setOpenSnackbar] = React.useState(false);
  //   const { items, addItem, reset } = useUniqueItems();
  //   const { enqueueSnackbar } = useSnackbar();

  //   const [anchorPosition, setAnchorPosition] = useState<{
  //     top: number;
  //     left: number;
  //   } | null>(null);

  //   // 只是前端的随机 key，不是后端 SECRET_KEY
  //   const secretKey = "xEsUxedg<@htfr";
  //   const open = Boolean(anchorPosition);
  //   const id = open ? "simple-popover" : undefined;

  //   const {
  //     messages,
  //     input,
  //     setInput,
  //     sendMessage,
  //     approve,
  //     reject,
  //     streaming,
  //     thinkingBuffer,
  //     toggleCollapse,
  //   } = useAIChat();

  //   const fetchPepeHoney = async (walletAddress: string) => {
  //     try {
  //       if (!walletAddress) return;

  //       setLoading(true);
  //       setError("");

  //       // 验证合约地址格式
  //       if (!ethers.isAddress(walletAddress)) {
  //         setOpenSnackbar(true);
  //         setError("Invalid contract address");
  //         return;
  //       }

  //       const response = await fetch(
  //         `${apiUrl}/airdrop?wallet=${walletAddress}&t=` + new Date().getTime(),
  //       );

  //       if (!response.ok) {
  //         throw new Error("Fetch API error");
  //       }

  //       const res = await response.json();
  //       setCoins(res.payload.coin);
  //       setUID(res.payload.uid);
  //       setClaim(Boolean(res.payload.claim));
  //       setLoading(false);
  //     } catch (error) {
  //       console.error("Error fetching PepeHoney:", error);
  //       return null;
  //     }
  //   };

  //   const handleClick = (event: any) => {
  //     const rect = event.currentTarget.getBoundingClientRect();
  //     setAnchorPosition({ top: rect.bottom, left: rect.left });
  //   };

  //   const handleClose = () => {
  //     setAnchorPosition(null);
  //   };

  //   const handleClickSnackbar = () => {
  //     setOpenSnackbar(true);
  //   };

  //   const handleCloseSnackbar = (
  //     event?: React.SyntheticEvent | Event,
  //     reason?: SnackbarCloseReason,
  //   ) => {
  //     if (reason === "clickaway") {
  //       return;
  //     }
  //     setOpenSnackbar(false);
  //   };

  //   const getSignature = async () => {
  //     // 获取当前时间戳
  //     const timestamp = Date.now().toString();

  //     // 前端计算签名（前端的 SECRET_KEY 只用于加密，真实密钥只在后端）
  //     const encoder = new TextEncoder();
  //     const key = await crypto.subtle.importKey(
  //       "raw",
  //       encoder.encode(secretKey),
  //       { name: "HMAC", hash: "SHA-256" },
  //       false,
  //       ["sign"],
  //     );

  //     const signature = await crypto.subtle.sign(
  //       "HMAC",
  //       key,
  //       encoder.encode(timestamp),
  //     );

  //     const signatureHex = Array.from(new Uint8Array(signature))
  //       .map((b) => b.toString(16).padStart(2, "0"))
  //       .join("");

  //     return { timestamp, signatureHex };
  //   };

  //   const handleClaim = async () => {
  //     try {
  //       if (!address || claim) return;

  //       setLoading(true);
  //       setError("");

  //       // 验证合约地址格式
  //       if (!ethers.isAddress(address)) {
  //         setOpenSnackbar(true);
  //         setError("Invalid contract address");
  //         return;
  //       }

  //       const response = await fetch("/v1/api/fetchClaim", {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({ wallet: address, id: uid }),
  //       });

  //       if (!response.ok) {
  //         throw new Error("Fetch API error");
  //       }

  //       const res = await response.json();
  //       setClaim(Boolean(res.claim));
  //       setLoading(false);
  //     } catch (error) {
  //       console.error("Error fetching PepeHoney:", error);
  //       return null;
  //     }
  //   };

  //   const disconnectWallet = () => {
  //     disconnect();
  //     setAccount(null);
  //     setCoins(0);
  //     localStorage.removeItem("walletAddress");
  //   };

  //   useEffect(() => {
  //     setLoading(false);
  //     setError("");
  //     setAccount(null);
  //     setCoins(0);
  //     setClaim(false);
  //     if (address) {
  //       setAccount(address);
  //       fetchPepeHoney(address);
  //     }
  //   }, [address, chain]);

  //   useEffect(() => {
  //     setInput("Beralink Astro");
  //     sendMessage();
  //     console.log("AI Chat initialized with greeting message.");
  //   }, []);

  return (
    //     <>
    //       {loading && <LoadingPage text="Loading NFTs Search Engines" />}
    //       <div
    //         className={`page-content ${!loading ? "loaded left-nav-sidebar" : ""}`}
    //       >
    //         <Navigation name="dashboard" />
    //         <section className="local-no-padding md-padding-80px-top xs-padding-80px-top sm-padding-80px-top">
    //           <div className="container">
    //             <div className="row">
    //               <div className="top-filter col-12 flex align-items-center justify-content-between px-[15px]">
    //                 <div
    //                   className={"flex items-center gap-[12px] w-full justify-end"}
    //                 >
    //                   <ConnectButton.Custom>
    //                     {({
    //                       account: walletAccount,
    //                       chain,
    //                       openAccountModal,
    //                       openChainModal,
    //                       openConnectModal,
    //                       authenticationStatus,
    //                       mounted,
    //                     }) => {
    //                       // Note: If your app doesn't use authentication, you
    //                       // can remove all 'authenticationStatus' checks
    //                       const ready =
    //                         mounted && authenticationStatus !== "loading";
    //                       const connected =
    //                         ready &&
    //                         walletAccount &&
    //                         chain &&
    //                         (!authenticationStatus ||
    //                           authenticationStatus === "authenticated");

    //                       return (
    //                         <div
    //                           {...(!ready && {
    //                             "aria-hidden": true,
    //                             style: {
    //                               opacity: 0,
    //                               pointerEvents: "none",
    //                               userSelect: "none",
    //                             },
    //                           })}
    //                         >
    //                           {(() => {
    //                             if (!connected) {
    //                               return (
    //                                 <button
    //                                   className="glow-on-hover"
    //                                   onClick={openConnectModal}
    //                                   type="button"
    //                                 >
    //                                   Connect Wallet
    //                                 </button>
    //                               );
    //                             }

    //                             if (chain.unsupported) {
    //                               return (
    //                                 <button
    //                                   className="glow-on-hover"
    //                                   onClick={openChainModal}
    //                                   type="button"
    //                                 >
    //                                   Wrong network
    //                                 </button>
    //                               );
    //                             }

    //                             return (
    //                               <div style={{ display: "flex", gap: 12 }}>
    //                                 <button
    //                                   onClick={openChainModal}
    //                                   className="chainSelect"
    //                                   style={{
    //                                     display: "flex",
    //                                     alignItems: "center",
    //                                   }}
    //                                   type="button"
    //                                 >
    //                                   {chain.hasIcon && chain.iconUrl && (
    //                                     <img
    //                                       alt={chain.name ?? "Chain icon"}
    //                                       src={chain.iconUrl}
    //                                       style={{ width: 25, height: 25 }}
    //                                     />
    //                                   )}
    //                                   {chain.name}
    //                                   <svg
    //                                     style={{
    //                                       position: "inherit",
    //                                       width: "24px",
    //                                     }}
    //                                     className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiSelect-icon MuiSelect-iconOutlined css-lohd6h-MuiSvgIcon-root-MuiSelect-icon"
    //                                     focusable="false"
    //                                     aria-hidden="true"
    //                                     viewBox="0 0 24 24"
    //                                     data-testid="ArrowDropDownIcon"
    //                                   >
    //                                     <path d="M7 10l5 5 5-5z"></path>
    //                                   </svg>
    //                                 </button>

    //                                 <button
    //                                   className="glassIco"
    //                                   onClick={handleClick}
    //                                 >
    //                                   <WalletAvatar
    //                                     address={walletAccount?.address}
    //                                     size={8}
    //                                     scale={4}
    //                                   />
    //                                 </button>
    //                                 <Popover
    //                                   className="wallet-popover"
    //                                   id={id}
    //                                   open={open}
    //                                   anchorReference="anchorPosition"
    //                                   onClose={handleClose}
    //                                   anchorPosition={
    //                                     anchorPosition || { top: 0, left: 0 }
    //                                   }
    //                                 >
    //                                   <div className="wallet-contain">
    //                                     <div>
    //                                       <p>
    //                                         <span>Address</span>
    //                                       </p>
    //                                       <p className="content">{account}</p>
    //                                     </div>
    //                                     <hr></hr>
    //                                     <IconButton
    //                                       onClick={disconnectWallet}
    //                                       className="wallet-logout"
    //                                       size="large"
    //                                     >
    //                                       <ExitToAppIcon />
    //                                     </IconButton>
    //                                   </div>
    //                                 </Popover>
    //                               </div>
    //                             );
    //                           })()}
    //                         </div>
    //                       );
    //                     }}
    //                   </ConnectButton.Custom>
    //                 </div>
    //               </div>
    //             </div>
    //           </div>
    //           <div className="container-fluid">
    //             <div className="row">
    //               <div className="col-12 filter-cover overflow-hidden text-center text-3xl text-white">
    //                 <div className="claim">
    //                   <span className="claim-font text-[#ffc107]">
    //                     {address ? "Your can get " + coins + " PepeHoney" : ""}
    //                   </span>
    //                   {address && coins > 0 ? (
    //                     <div className="claim-container">
    //                       <button
    //                         disabled={claim}
    //                         className={
    //                           claim
    //                             ? "splitgate-button small green"
    //                             : "splitgate-button small yellow"
    //                         }
    //                         onClick={() => handleClaim()}
    //                       >
    //                         {claim ? "You have already claimed" : "Claim NOW"}
    //                       </button>
    //                     </div>
    //                   ) : (
    //                     ""
    //                   )}
    //                 </div>
    //               </div>
    //             </div>
    //           </div>
    //         </section>

    //         <div
    //           style={{
    //             maxWidth: 900,
    //             margin: "0 auto",
    //             padding: 24,
    //           }}
    //         >
    //           <h2>AI Chat</h2>

    //           {/* messages */}
    //           <div
    //             style={{
    //               border: "1px solid #ddd",
    //               borderRadius: 12,
    //               padding: 20,
    //               height: 600,
    //               overflowY: "auto",
    //               background: "#0f172a",
    //             }}
    //           >
    //             {messages.map((msg, index) => {
    //               // assistant card
    //               if (msg.role === "assistant") {
    //                 return (
    //                   <AssistantCard
    //                     key={index}
    //                     title={msg.title}
    //                     content={msg.content}
    //                     collapsed={msg.collapsed}
    //                     completed={msg.completed}
    //                     onToggle={() => toggleCollapse(index)}
    //                   />
    //                 );
    //               }

    //               // awaiting
    //               if (msg.role === "awaiting") {
    //                 return (
    //                   <div
    //                     key={index}
    //                     style={{
    //                       marginBottom: 24,
    //                       color: "#fff",
    //                       padding: "20px",
    //                       borderRadius: 10,
    //                       backgroundColor: "#219ebc",
    //                     }}
    //                   >
    //                     <div
    //                       style={{
    //                         fontWeight: "bold",
    //                         marginBottom: 14,
    //                       }}
    //                     >
    //                       {msg.content}
    //                     </div>

    //                     <div
    //                       style={{
    //                         display: "flex",
    //                         gap: 12,
    //                       }}
    //                     >
    //                       <button
    //                         onClick={approve}
    //                         style={{
    //                           padding: "10px 18px",

    //                           borderRadius: 999,

    //                           border: "none",

    //                           background: "#fb8500",

    //                           color: "#fff",

    //                           cursor: "pointer",
    //                         }}
    //                       >
    //                         Activate
    //                       </button>

    //                       <button
    //                         onClick={reject}
    //                         style={{
    //                           padding: "10px 18px",

    //                           borderRadius: 999,

    //                           border: "1px solid #ccc",

    //                           color: "#0f172a",
    //                           background: "#fff",

    //                           cursor: "pointer",
    //                         }}
    //                       >
    //                         Skip
    //                       </button>
    //                     </div>
    //                   </div>
    //                 );
    //               }

    //               // user bubble
    //               return (
    //                 <div
    //                   key={index}
    //                   style={{
    //                     marginBottom: 20,

    //                     textAlign: "right",
    //                   }}
    //                 >
    //                   <div
    //                     style={{
    //                       display: "inline-block",

    //                       padding: "12px 16px",

    //                       borderRadius: 16,

    //                       maxWidth: "80%",

    //                       background: "#fb8500",

    //                       color: "#fff",

    //                       whiteSpace: "pre-wrap",
    //                     }}
    //                   >
    //                     {msg.content}
    //                   </div>
    //                 </div>
    //               );
    //             })}

    //             {/* streaming thinking */}
    //             {streaming && (
    //               <div
    //                 style={{
    //                   marginBottom: 20,
    //                 }}
    //               >
    //                 <div
    //                   className="text-slate-300 font-medium"
    //                   style={{
    //                     display: "inline-block",

    //                     width: "100%",

    //                     padding: "12px 16px",

    //                     borderRadius: 16,

    //                     background: "#219ebc",

    //                     fontFamily: "Rubik, monospace",
    //                     height: 100,
    //                     minHeight: 100,
    //                     overflow: "hidden",
    //                     whiteSpace: "pre-wrap",
    //                   }}
    //                 >
    //                   <div className="flex items-center gap-0.5 font-medium">
    //                     <svg
    //                       xmlns="http://www.w3.org/2000/svg"
    //                       viewBox="0 0 24 24"
    //                       fill="none"
    //                       stroke="currentColor"
    //                       strokeWidth="3.5"
    //                       strokeLinecap="round"
    //                       strokeLinejoin="round"
    //                       className={`w-5 h-5 text-[#fb8500] animate-ai-think`}
    //                     >
    //                       <path d="M21 12a9 9 0 1 1-6.21-8.58" />
    //                     </svg>{" "}
    //                     AI Agent is thinking...
    //                   </div>
    //                   {thinkingBuffer}
    //                   <span>▌</span>
    //                 </div>
    //               </div>
    //             )}
    //           </div>

    //           {/* input */}
    //           <div
    //             style={{
    //               display: "flex",

    //               gap: 12,

    //               marginTop: 20,
    //             }}
    //           >
    //             <input
    //               value={input}
    //               onChange={(e) => setInput(e.target.value)}
    //               placeholder="Ask something..."
    //               style={{
    //                 flex: 1,

    //                 padding: 14,

    //                 borderRadius: 10,

    //                 border: "1px solid #ccc",
    //               }}
    //             />

    //             <button
    //               onClick={sendMessage}
    //               style={{
    //                 background: "#007bff",

    //                 color: "#fff",

    //                 border: "none",

    //                 borderRadius: 10,

    //                 padding: "0 24px",

    //                 cursor: "pointer",
    //               }}
    //             >
    //               Send
    //             </button>
    //           </div>
    //         </div>

    //         <Snackbar
    //           open={openSnackbar}
    //           autoHideDuration={6000}
    //           onClose={handleCloseSnackbar}
    //         >
    //           <Alert
    //             onClose={handleCloseSnackbar}
    //             severity="error"
    //             variant="filled"
    //             sx={{ width: "100%" }}
    //           >
    //             {error}
    //           </Alert>
    //         </Snackbar>
    //       </div>
    //     </>
    <></>
  );
};
